'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defineProperty = require('../node_modules/@babel/runtime/helpers/esm/defineProperty.js');
require('react');
require('prop-types');
var useUtilsCfb96ac9 = require('./useUtils-cfb96ac9.js');
var makePickerWithState5a79cb8a = require('./makePickerWithState-5a79cb8a.js');
var PickerCcd9ba90 = require('./Picker-ccd9ba90.js');
var TimePickerToolbar81100fab = require('./TimePickerToolbar-81100fab.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultProps = _objectSpread({}, PickerCcd9ba90.t, {
  openTo: 'hours',
  views: ['hours', 'minutes']
});

function useOptions(props) {
  var utils = useUtilsCfb96ac9.u();
  return {
    getDefaultFormat: function getDefaultFormat() {
      return makePickerWithState5a79cb8a.p(props.format, props.ampm, {
        '12h': utils.time12hFormat,
        '24h': utils.time24hFormat
      });
    }
  };
}

var TimePicker = makePickerWithState5a79cb8a.m({
  useOptions: useOptions,
  Input: makePickerWithState5a79cb8a.a,
  useState: makePickerWithState5a79cb8a.u,
  DefaultToolbarComponent: TimePickerToolbar81100fab.T
});
var KeyboardTimePicker = makePickerWithState5a79cb8a.m({
  useOptions: useOptions,
  Input: makePickerWithState5a79cb8a.K,
  useState: makePickerWithState5a79cb8a.b,
  DefaultToolbarComponent: TimePickerToolbar81100fab.T,
  getCustomProps: function getCustomProps(props) {
    return {
      refuse: props.ampm ? /[^\dap]+/gi : /[^\d]+/gi
    };
  }
});
TimePicker.defaultProps = defaultProps;
KeyboardTimePicker.defaultProps = defaultProps;

exports.KeyboardTimePicker = KeyboardTimePicker;
exports.TimePicker = TimePicker;
